<template>
  <div class="container">
    <p style="text-align: center; font-weight: 700; font-size: 30px">
      金融助力激发“新动能”
    </p>
    <br />
    <p style="text-indent: 2em">
      农业银行获嘉支行积极开展针对农村农户贷款重点支持，打通金融支持“快车道”。获嘉县各营业网点开通信贷服务，为农户生产经营提供金融支持，企业及个人可依据<span
        style="font-weight: 700"
        >自身经营项目</span
      >提出融资需求，农业银行获嘉支行对提出融资需求的企业及个人快审批、快放款，满足农户生产经营的融资需求，以金融助力农户经营可持续、健康的发展。
    </p>
    <br />
    <p style="text-indent: 2em">
      <span style="font-weight: 700">贷款对象:</span
      >符合农业银行获嘉县支行贷款基本条件，且取得获嘉县农村产权交易中心出具的《产权交易鉴定书》的企业及个人。
    </p>
    <p style="text-indent: 2em">
      <span style="font-weight: 700">贷款额度:</span
      >个人信用类最高50万元，担保最高300万元、抵押类最高1000万元；企业信用最高300万元，抵押最高根据企业规模及抵押物价值综合评估授信额度。
    </p>
    <p style="text-indent: 2em">
      <span style="font-weight: 700">贷款利率:</span
      >最低可执行一年期LPR利率下浮30BP(具体根据客户实际经营情况确定贷款利率）。
    </p>
    <p style="text-indent: 2em">
      <span style="font-weight: 700">贷款用途:</span
      >用于产权交易中心签订的用途使用贷款资金。
    </p>
    <p style="text-indent: 2em">
      <span style="font-weight: 700">贷款期限:</span>单笔贷款一年、三年循环。
    </p>
    <br />
    <p style="text-align: center; font-weight: 700; font-size: 30px">
      贷款流程
    </p>
    <div
      style="
        display: flex;
        align-items: center;
        width: 100%;
        flex-flow: column nowrap;
      "
    >
      <img
        style="width: 400px"
        src="@/assets/金融服务/获嘉县_贷款流程.png"
        alt=""
      />
      <img
        style="width: 1200px"
        src="@/assets/金融服务/金融服务_获嘉.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      bankList: [
      ]
    }
  },
}
</script>

<style lang="scss" scoped>
* {
  box-sizing: border-box;
}
.container {
  min-height: 630px;
  margin: 0 auto;
  width: 1860px;
  background-color: #fff;
  box-shadow: 0px 0px 24px rgba(21, 21, 21, 0.1);
  padding: 0 30px;
  padding-top: 30px;
  p {
    font-size: 24px;
    text-align: left;
  }
  img {
    display: block;

    height: auto;
  }
}
</style>